module.exports = __webpack_public_path__ + "static/media/faraday-logo-dark.ce97099f.svg";